import React from "react";
import { Grid, Box, Text, Button, Select } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { IconClearAll, IconSearch } from "@tabler/icons-react";
import dayjs from "dayjs";
import type { IFiltroMonitorVistaProps } from "../interfaces";

const FiltroMonitorVista: React.FunctionComponent<IFiltroMonitorVistaProps> = ({
    filtro,
    consultarTrazabilidad,
    entidadesRegistro,
    manejarCambioFiltroMonitor,
    limpiarFiltros,
    cargando
}) => {
    return (
        <Box pb="sm">
            <Grid gutter="sm" align="flex-end">
                <Grid.Col span={{ base: 12, md: 4 }}>
                    <Select
                        label={'Técnico'}
                        placeholder="Seleccionar técnico..."
                        value={filtro.UsuarioId != null ? String(filtro.UsuarioId) : null}
                        onChange={(value) => {
                            manejarCambioFiltroMonitor("UsuarioId", value ? Number(value) : null);
                        }}
                        required
                        comboboxProps={{ zIndex: 1000000 }}
                        data={entidadesRegistro.Tecnicos.map(tecnico => ({
                            value: tecnico.Id.toString(),
                            label: tecnico.NombreCompleto
                        }))}
                        clearable
                        searchable
                        size="xs"
                        error={!filtro.UsuarioId ? undefined : false}
                    />
                </Grid.Col>

                <Grid.Col span={{ base: 12, md: 4 }}>
                    <DatePickerInput
                        size="xs"
                        popoverProps={{ zIndex: 1000000 }}
                        valueFormat="DD/MM/YYYY"
                        label="Fecha"
                        placeholder="Seleccione una fecha"
                        locale="es"
                        value={filtro.Fecha ? dayjs(filtro.Fecha).toDate() : null}
                        onChange={(val) => {
                            const fechaStr = val ? dayjs(val).format('YYYY-MM-DD') : null;
                            manejarCambioFiltroMonitor('Fecha', fechaStr);
                        }}
                        required
                        clearable={false}
                    />
                </Grid.Col>

                <Grid.Col
                    span={{ base: 12, md: 4 }}
                    style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        gap: "0.5rem"
                    }}
                >
                    <Button
                        onClick={limpiarFiltros}
                        color="primary"
                        variant="light"
                        fullWidth={true}
                        size="compact-sm"
                        radius="lg"
                        rightSection={<IconClearAll opacity={1} size={12} />}
                        disabled={cargando}
                    >
                        <Text fw={500} fz={11}>Limpiar</Text>
                    </Button>

                    <Button
                        onClick={consultarTrazabilidad}
                        color="primary"
                        variant="filled"
                        fullWidth={true}
                        size="compact-sm"
                        radius="lg"
                        rightSection={<IconSearch opacity={1} size={12} />}
                        disabled={cargando || !filtro.UsuarioId || !filtro.Fecha}
                    >
                        <Text fw={500} fz={11}>Consultar</Text>
                    </Button>
                </Grid.Col>
            </Grid>
        </Box>
    );
};

export default FiltroMonitorVista;
